import React, { useState } from 'react';
import { useMemo } from 'react';
import { LoadingSpinner } from '../../../../components/LoadingSpinner';
import { Toggle } from '../../../../components/Toggle';

interface FeatureToggleItemProps {
  children?: React.ReactNode;
  value: boolean;
  onChange: (value: boolean) => Promise<void>;
  solo?: boolean;
  indent?: number;
}

export default function FeatureToggleItem({
  children,
  value,
  onChange,
  solo = false,
  indent = 0,
}: FeatureToggleItemProps) {
  const [loading, setLoading] = useState(false);

  const style = useMemo(() => {
    if (!solo) return '';

    return 'border border-gray-default rounded-2';
  }, [solo]);

  const hoverStyle = useMemo(() => {
    if (indent > 0 || solo) return 'hover:bg-gray-default';
    return 'hover:bg-gray-darker';
  }, [indent]);

  const handleChange = async (value: boolean) => {
    setLoading(true);
    await onChange(value);
    setLoading(false);
  };

  return (
    <button
      onClick={async () => await handleChange(!value)}
      className={`${style} ${hoverStyle} flex w-full items-center justify-between gap-4 px-4 py-3 text-left `}
    >
      <div style={{ paddingLeft: indent * 16 }}>{children}</div>
      <div className='flex items-center gap-4'>
        {loading && <LoadingSpinner />}
        <Toggle value={value} size={indent > 0 ? 'sm' : 'md'} onChange={() => {}} />
      </div>
    </button>
  );
}
